"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SimpleStyledClickable = _interopRequireDefault(require("./internal/SimpleStyledClickable"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var UITextToolbarButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITextToolbarButton, _PureComponent);

  function UITextToolbarButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITextToolbarButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextToolbarButton).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UITextToolbarButton, [{
    key: "handleClick",
    value: function handleClick(evt) {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          onSelectedChange = _this$props.onSelectedChange,
          selected = _this$props.selected;
      onSelectedChange((0, _SyntheticEvent.default)(!selected));
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          __onSelectedChange = _this$props2.onSelectedChange,
          selected = _this$props2.selected,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["onSelectedChange", "selected"]);
      return _react.default.createElement(_SimpleStyledClickable.default, (0, _extends2.default)({}, rest, {
        "aria-pressed": selected,
        onClick: this.handleClick
      }));
    }
  }]);
  return UITextToolbarButton;
}(_react.PureComponent);

UITextToolbarButton.propTypes = {
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  onSelectedChange: _react.PropTypes.func,
  selected: _react.PropTypes.bool
};
UITextToolbarButton.defaultProps = {
  selected: false
};
UITextToolbarButton.displayName = 'UITextToolbarButton';

var _default = (0, _Controllable.default)(UITextToolbarButton, ['selected']);

exports.default = _default;
module.exports = exports.default;